<template>
  <div class="space-y-8">
    <h3 class="text-lg leading-6 font-medium text-gray-900">Details</h3>
    <table class="min-w-full">
      <PreviewLineItemsHeader />
      <tbody class="relative">
        <template v-for="lineItem in lineItems">
          <PreviewLineItemsItem :key="lineItem.id" :acc-order-line-item="lineItem" />
        </template>
        <tr>
          <td
            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border"
            colspan="3"
          >
            Sub total
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border text-right">
            {{ subtotal }}
          </td>
        </tr>
        <tr>
          <td
            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border"
            colspan="3"
          >
            Shipping total
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border text-right">
            {{ shippingTotal }}
          </td>
        </tr>
        <tr>
          <td
            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border"
            colspan="3"
          >
            Payment method
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border text-right">
            {{ accOrder.paymentMethodTitle }}
          </td>
        </tr>
        <tr>
          <td
            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border"
            colspan="3"
          >
            Total
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border text-right">
            {{ total }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from 'moment';
import numbro from '@/utils/numbro';
import PreviewLineItemsHeader from './PreviewLineItemsHeader.vue';
import PreviewLineItemsItem from './PreviewLineItemsItem.vue';

export default {
  components: {
    PreviewLineItemsHeader,
    PreviewLineItemsItem,
  },
  props: {
    accOrder: {
      type: Object,
      required: true,
    },
  },
  computed: {
    lineItems() {
      return (this.accOrder.lineItems || []).map(
        (id) => this.$store.state.entities.accOrderLineItems.byId[id]
      );
    },
    dateCreated() {
      return moment(this.accOrder.dateCreated).format('DD MMM YYYY');
    },
    subtotal() {
      const subTotal = this.lineItems.reduce((total, current) => total + current.total, 0);

      return numbro(subTotal).formatCurrency({
        mantissa: 2,
        spaceSeparated: true,
      });
    },
    shippingTotal() {
      return numbro(this.accOrder.shippingTotal).formatCurrency({
        mantissa: 2,
        spaceSeparated: true,
      });
    },
    total() {
      return numbro(this.accOrder.total).formatCurrency({
        mantissa: 2,
        spaceSeparated: true,
      });
    },
  },
};
</script>
